import { formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, OnInit, ViewRef,Input,Output,EventEmitter, ViewChild, ElementRef } from '@angular/core'
import { MatDialog } from '@angular/material'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, StateService, TiersService, VisiteService } from '../../../../../services'
import * as moment from 'moment'
import {
	Observable,
	BehaviorSubject,	
	Subject
} from "rxjs";
import { FormControl } from '@angular/forms'
import { map, startWith } from 'rxjs/operators'


const KEY = 'consultation-slider'

@Component({
	selector: 'atyl-consultation-slider',
	templateUrl: './consultation-slider.component.html',
	styleUrls: ['./consultation-slider.component.scss'],
})

@Stringable({
	path: 'views/pages/consultation/index',
	key: KEY,
})
export class ConsultationSliderComponent implements OnInit {
	@Input() oneday:boolean=false;
	@Input() read;

    @Input() loadConsultation:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
    @Input() loadDate:BehaviorSubject<Date>=new BehaviorSubject<Date>(new Date());
    @Input() loadProfessionel:BehaviorSubject<number[]>=new BehaviorSubject<number[]>([]);

	@Input() consultModif:any;
	
	@Output() loaded = new EventEmitter<boolean>();
	subscription: Subscription[] = [];

	consultationList: any[] = [];
	consultationTypeList: any[] = [];
	filters: any = [];

	// Inputs des filtres
	typeInput: string = '';
	pickedDateInput: string = '';

	showAdvanceSearch: boolean = false;
	sort: any
	  day:any = new Date();

	hiddenElements: boolean = true;
	fromQueryParams: ParamMap
	@StringableValues(KEY)
	strings: any
	
    loading: Boolean=false;
   
    eventsLoadinguserSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    
    
    myConsultation: Boolean=true;
    myEvents: Boolean=false;
    
    viewVisite: Boolean=true;
	viewConsult: Boolean=true;
	
    Moi: any = [];
    tiersListGroupe: any = [];
    tiersListAutres: any = [];
    dateF: any;
    tierSelect: string;
    tierSelected: number[]=[];
    
    loadedTiers:boolean=true;

	weekInFrance: any = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
	week:any = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	weekObj:any = {
		Mon: 0,
		Tue: 1,
		Wed: 2,
		Thu: 3,
		Fri: 4,
		Sat: 5,
		Sun: 6,
	}

	consultModifObj:any = null;

	lieux: any[] = [];
	townOptions: Observable<any[]>;
	town:any[] = [];
	locationFormControl = new FormControl('', []);
	@ViewChild('locationListInput', { read: undefined, static: undefined }) locationListInput: ElementRef<HTMLInputElement>
	updateLocationsInputNext:any = null;
	initLieuSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);

	showAllDays = false;
    
	selectedOption: string = 'week';
	displayCalendarWeek:boolean=true;
	eventsDateRerenceSubject: Subject<Date> = new Subject<Date>();
	liste:  any = [];
	
	constructor(
		private consultationService: ConsultationService,
		private visiteService: VisiteService,
		private changeDetectorRef: ChangeDetectorRef,
		public dialog: MatDialog,
        private tiersService: TiersService,

	) {
	}

	ngOnInit() {
		this.eventsDateRerenceSubject.next(this.day);
		
		if(this.consultModif != undefined){
			this.consultModif.subscribe((consult)=>{
				this.consultModifObj = consult.obj;
				//console.log("___consultObj",consult,this.oneday)
				if(consult.event == "location" || consult.event == "consultationSelect" || consult.event == "initConsult"){
					var consultLieuID = null;
					if(consult.type == "rdv"){
						if(this.consultModifObj.visitesTemp.length>0)
							consultLieuID = this.consultModifObj.visitesTemp[0].lieuid
					}
					else{
						consultLieuID = this.consultModifObj.lieu
					}
					if(consultLieuID){
						if(this.town.length > 0){
							this.updateLieux(consultLieuID);
						}
						else{
							this.updateLocationsInputNext = consultLieuID;
						}
					}
				}
				if(this.oneday){
					if(consult.event == "date"){
						this.day = this.consultModifObj.datedebut;
					}
					else{
						this.getConsultations(this.day);
					}
				}
			})
		}


        if(this.read != undefined && this.read){
            this.dateF = this.read.dateF;
            var format = (f: any) =>{
                let jour = f[8]+f[9]; 
                let mois = f[5]+f[6]; 
                let annee = f[0]+f[1]+f[2]+f[3];
               
                return jour+"/"+mois+"/"+annee;
            };
            let date = new Date( Date.parse(this.dateF));
            if(this.dateF == undefined){
                this.day= new Date()
            }else{
                this.day = date;
                this.dateF = format(this.dateF);
            }
        }else{
            if (this.day==undefined
                || !this.day)
                 this.day= new Date();
        }
        console.log("ConsultationSliderComponent init",this.day,this.loadConsultation)
        
       if (this.loadConsultation) {
		   
	       this.subscription.push( this.loadConsultation.subscribe((status)=>{
		  //   console.log("ConsultationSliderComponent zozo",this.day,status)
	        	if (status) {
						//this.loadTiersList();
						this.eventsLoadinguserSubject.next(true);
					// 	console.log("ConsultationSliderComponent load default",this.day)
						
						this.loadConsultation=new BehaviorSubject<boolean>(false);
	        			//this.getConsultations(this.day); 
	        			let _opts:any={
									  
						}
	        			this.loadProfessionel.subscribe((pros)=>{
								 /* if (pros.length>0)
								    this.tierSelect=pros[0]+"";
								  */
								this.tierSelected=pros;
							//	console.log("ConsultationSliderComponent loadProfessionel",this.day,_opts)
						});

						this.loadDate.subscribe((mydate)=>{
						 //    console.log("ConsultationSliderComponent loadDate",this.day,mydate)
					        	if (mydate) {
				                    if(!this.dateF && this.oneday){
				                        //console.log("test test test:",this.dateF);
										this.day=mydate;
				                    }
					        		
								}
						});
						
						this.ConsultationLocations();
	        					
				}
			  }
			)
			);
			
		}
	}

	ngOnDestroy() {
		this.subscription.forEach((sub: Subscription) => {
			//console.log("ConsultationSliderComponent unsubscribe",sub)
			sub.unsubscribe();
		})
		
		
	}

    tiersSelect(ID: string){
        //console.log("le sélectionné:",ID);
        this.tierSelect = ID;
		this.getConsultations(this.day);
    }

    loadTiersList() {
		if (this.loadedTiers)
	        this.tiersService.list("", ["PMI", "ADMIN"]).subscribe((res) => {
	            let tiersList = res.result;
	            tiersList.forEach(element => {
	                if(element['sector'] == 1){
	                    this.tiersListGroupe.push(element);
	                }else if(element['sector'] == 0){
	                    this.tiersListAutres.push(element);
	                }else{
	                    this.Moi.push(element);
	                    this.tierSelect = element.ID;
	                }
	            });
	            this.loadedTiers=false;
	            this.changeDetectorRef.detectChanges();
	        });
    }

   onLoadConsultations() {
		this.getConsultations(this.day);
	}

	// Affiche les consultations avec le jour (day) et les options si besoin
	getConsultations(day: Date, options?: any) {
        this.loading=true;
		this.consultationList = []
		this.eventsDateRerenceSubject.next(this.day);
		this.liste = [];
		
		let monday = formatDate(this.getMonday(day), 'dd/MM/yyyy', 'fr')
		let friday = formatDate(this.getSunday(day), 'dd/MM/yyyy', 'fr')

		if (!this.displayCalendarWeek) {
					monday = formatDate(this.firstDayOfMonth(day), 'dd/MM/yyyy', 'fr');
					friday = formatDate(this.lastDayOfMonth(day), 'dd/MM/yyyy', 'fr');
		}
				
		
		if (this.oneday) {
			
			 monday = formatDate(day, 'dd/MM/yyyy', 'fr')
		     friday = formatDate(day, 'dd/MM/yyyy', 'fr')
			 //index = this.weekObj[week[this.getDay(day)]]
		}

		let consultationOptions = {
			datedebut:  monday + ' 00:00:00',
			datefin:   friday + ' 23:59:59'
		}
		if(this.lieux.length>0)
			consultationOptions["lieux"] = this.lieux;

        options = this.getFilterOption();

		// Rajouter ici d'autres options pour les filtres
		if (options) {
			if (typeof options.type !== 'undefined') {
				consultationOptions['type'] = options['type']
			}
			
			if (typeof options.mine !== 'undefined') {
				consultationOptions['mine'] = options['mine']
			}

			if (typeof options.agenda !== 'undefined') {
				consultationOptions['agenda'] = options['agenda']
			}
		}
        consultationOptions["visite"]= true ;

        consultationOptions["select"] = this.tierSelect ;
        if (this.tierSelected.length>0) {
			consultationOptions["select"]=this.tierSelected;
		}	
		if(this.consultModifObj){
			consultationOptions["tempObj"] = { ...this.consultModifObj };
		}
		var consultListTemp = {...this.consultationList};
     //   console.log("consultationOptions slider:",consultationOptions);
	//	console.log("consultationList",consultListTemp);
	    consultationOptions["viewOnly"]={
			"visit": this.viewVisite,
	        "consult": this.viewConsult
	    }
	    this.visiteService
		.listWithConsultation(consultationOptions) 
		.subscribe((res: JSONRpcResponse) => {
					if(res && res.result){
						this.liste = res.result;
						
						let dateArray = monday.split('/')
						let newdate = dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2]
						let mondayDate = new Date(newdate)
						let today = new Date();
						if (this.oneday) {
					//		console.log("oneday",this.day,this.day instanceof Date );
							if (!(this.day instanceof Date) && this.day._d!=undefined  ) {
								this.day=this.day._d;
							}
							let indexDay = this.weekObj[this.week[this.getDay(this.day)]]
							this.consultationList[0] = {}
							this.consultationList[0].consultation = []
							this.consultationList[0].consultationID = []
							this.consultationList[0].consultation_hours = []
							
							/*let consDate = new Date(
								mondayDate.getFullYear(),
								mondayDate.getMonth(),
								mondayDate.getDate() + indexDay
							)*/
							
							if (this.day instanceof Date ) {
								this.consultationList[0].date = this.formatDate(this.day)
								this.consultationList[0].isToday = this.formatDate(this.day) == this.formatDate(today)
								this.consultationList[0].isPast = this.day.getTime() < today.getTime()
								this.consultationList[0].isNext = this.day.getTime() > today.getTime()
								
								this.consultationList[0].name = this.weekInFrance[indexDay]
							}
						}
						else {
							for (let i = 0; i < 7; i++) {
								this.consultationList[i] = {}
								this.consultationList[i].consultation = []
								this.consultationList[i].consultationID = []
								this.consultationList[i].consultation_hours = []
								
								let consDate = new Date(
									mondayDate.getFullYear(),
									mondayDate.getMonth(),
									mondayDate.getDate() + i
								)
								this.consultationList[i].date = this.formatDate(consDate)
								this.consultationList[i].isToday = this.formatDate(consDate) == this.formatDate(today)
								this.consultationList[i].isPast = consDate.getTime() < today.getTime()
								this.consultationList[i].isNext = consDate.getTime() > today.getTime()
							}
				
							for (let i = 0; i < this.weekInFrance.length; i++) {
								this.consultationList[i].name = this.weekInFrance[i]
							}
						}
						//this.consultationList = {...consultListTemp};
						var nullIdx = 0;
                        res.result.forEach((visite: any) => {
							if(visite.ID == null){
								visite.ID = nullIdx;
								nullIdx--;
							}
							const datedebut = visite['date_debut']
							var index = this.weekObj[this.week[this.getDay(datedebut)]]
						//	console.log("visiteService",this.consultationList,index,"visite",visite);
							if (this.oneday) 
								index=0;
							if (
							   this.consultationList[index] !=undefined
							&&	!this.consultationList[index].consultationID.includes(visite.ID)) {
								   this.consultationList[index].consultation.push(visite);
								this.consultationList[index].consultationID.push(visite.ID);
								var hour=this.getHours(datedebut);
								if (this.consultationList[index].consultation_hours[hour]==undefined)
									this.consultationList[index].consultation_hours[hour]=[];
								this.consultationList[index].consultation_hours[hour].push(visite);       
			
							}
							
						});
                    }
					this.loading=false;
	                 if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
	                        this.changeDetectorRef.detectChanges()
					}	
				
//					console.log("consultationList",this.consultationList)
		})
		/*} else {
        
		
			
		this.consultationService
			.consultationListe(consultationOptions)	
			.subscribe((res: JSONRpcResponse) => {
                
                if (res.result.length==0) {
                     this.loading=false;
                    if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                        this.changeDetectorRef.detectChanges()
                    }
                }
                
                
				res.result.forEach((consultation: any) => {
					const datedebut = consultation['date_debut']
					var index = this.weekObj[week[this.getDay(datedebut)]]
					if (this.oneday) 
						index=0;
					if (!this.consultationList[index].consultationID.includes(consultation.ID)) {
					   this.consultationList[index].consultation.push(consultation);
					    this.consultationList[index].consultationID.push(
                                    consultation.ID
                                );
                         var hour=this.getHours(datedebut);
                         if (this.consultationList[index].consultation_hours[hour]==undefined)
						    this.consultationList[index].consultation_hours[hour]=[];
						 this.consultationList[index].consultation_hours[hour].push(consultation);       
                                
                                
					}
					
				})
				console.log("consultationList filled",this.consultationList);
				 this.loading=false;
                 if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                        this.changeDetectorRef.detectChanges()
				}
			})
			
		}	*/
		
	}
	
	getDay(date: any) {
		return new Date(date).getDay()
	}
	
	getHours(date: any) {
		let dt=new Date(date);
		let currentHours = dt.getHours();
		let currentHoursString:string = ("0" + currentHours).slice(-2);
		currentHoursString+=":00";
		return currentHoursString;
	}
	
	getMonday(date: string | number | Date) {
		date = new Date(date)
		let day = date.getDay(),
			diff = date.getDate() - day + (day == 0 ? -6 : 1)
		return new Date(date.setDate(diff))
	}

	getFriday(date: string | number | Date) {
		date = new Date(date)
		let day = date.getDay(),
			diff = date.getDate() + (5 - day) + (day == 0 ? -3 : 0)
		return new Date(date.setDate(diff))
	}
	

    getSunday(date: string | number | Date) {
        date = new Date(date)
        let day = date.getDay(),
            diff = date.getDate() + (7 - day)
        return new Date(date.setDate(diff))
    }
	
	formatDate(date: any) {
		return formatDate(
			date,
			'dd/MM/yyyy',
			'fr'
		)
	}
	
	getFilterOption()
    {
        let options = {}

        /*if (this.typeInput) {
            options['type'] = this.typeInput
        }
        */
        options['mine']=this.myConsultation;
        options['agenda']=this.myEvents;
        
        return options;
    }
    
    getTodayConsultations() {
        this.day =new Date();
        this.getConsultations(this.day)
    }

    getNextMonthConsultations() {
        if (this.oneday) {
			this.day = new Date(
				this.day.getFullYear(),
				this.day.getMonth(),
				this.day.getDate() +7
			)
		}
        else
        	this.day = new Date(
	            this.day.getFullYear(),
	            this.day.getMonth()+1,
	            this.day.getDate()
        )
        this.getConsultations(this.day)
    }

    getPreviousMonthConsultations() {
        
		if (this.oneday) {
			this.day = new Date(
				this.day.getFullYear(),
				this.day.getMonth(),
				this.day.getDate() -7
			)
		}
        else
	        this.day = new Date(
	            this.day.getFullYear(),
	            this.day.getMonth()-1,
	            this.day.getDate()
	        )
        this.getConsultations(this.day)
    }

	getNextWeekConsultations() {
		let dayadd:number=7;
		if (this.oneday) {
			dayadd=1;
			// Friday
	    	// if (this.getDay(this.day)==5)
			// 	dayadd=3;
			
		}
		
		this.day = new Date(
				this.day.getFullYear(),
				this.day.getMonth(),
				this.day.getDate() + dayadd
		)
		this.getConsultations(this.day)
	}

	getPreviousWeekConsultations() {
		let dayadd:number=7;
		if (this.oneday) {
			dayadd=1;
			if (this.getDay(this.day)==1)
				dayadd=3;
		}
		
		this.day = new Date(
			this.day.getFullYear(),
			this.day.getMonth(),
			this.day.getDate() - dayadd
		)
		this.getConsultations(this.day)
	}
	
	checkboxChange(event:any) {
		this.getConsultations(this.day);
		
	}
	
	updateDate($event:any) {
		console.log("updateDate before",this.day)
		let dayadd:number=0;
		if(!(this.day instanceof Date))
			this.day=this.day.toDate();	
		this.day = new Date(
			this.day.getFullYear(),
			this.day.getMonth(),
			this.day.getDate() + dayadd
		)
		console.log("updateDate",this.day)
		this.getConsultations(this.day);
		
	}
	
	onUserSelected(event:any) {
		//console.log("onUserSelected slider",event);
		this.tierSelect=event;
		this.getConsultations(this.day);
	}

	ConsultationLocations(){
        this.tiersService.consultPlace().subscribe(res =>{
		    let tt:any={
							
						}
            res.result.forEach((result: any) => {
                           
                let ll={
                    nom: result.NOM ? result.NOM : '',
                    number: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.number) ? result.adresses.PRINCIPALE.number : '',
                    complement: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.complement) ? result.adresses.PRINCIPALE.complement : '',
                    street: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.street) ? result.adresses.PRINCIPALE.street : '',
                    zipCode: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.IDzipcode) ? result.adresses.PRINCIPALE.IDzipcode : '',
                    town: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.town) ? result.adresses.PRINCIPALE.town : '',
                    type:(result.type_libelle != undefined && result.type_libelle) ? result.type_libelle : '',
                    insee: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.town) ? result.adresses.PRINCIPALE.INSEE : '',
                    ID: result.ID ? result.ID : ''
                };
                
                if (tt[ll.town]==undefined) {
							   tt[ll.town]={
								   label:ll.town,
								   consultations:[]
							   };
						   }
                 tt[ll.town].consultations.push(ll);
            })
            
            let tws:any[]= Object.keys(tt).sort((a,b) => ( a > b) ? 1:-1);
					   for (let i = 0; i <tws.length; i++) {
						  //  tt[tws[i]].consultationLocation.sort((a,b) => ( a.nom > b.nom) ? 1:-1);
							this.town.push(tt[tws[i]]);
			}
			if(this.updateLocationsInputNext){
				this.updateLieux(this.updateLocationsInputNext);
				this.getConsultations(this.day);
				this.updateLocationsInputNext = null;
			}

//			console.log("town list",tws,this.town,tt)
            
        });  
    }

	updateLieux(locationID){
		this.town.forEach(town => {
			var locationFind = town.consultations.find(lieu=>lieu.ID == locationID);
			if(locationFind){
				this.lieux = [{"ID": locationFind.ID,"NOM":locationFind.nom}];
				this.initLieuSubject.next(this.lieux);

			}
		});
	}

	locationChange(locations){
        this.lieux = locations;
    }
	
	showData() {
        let date = this.day
        if (this.pickedDateInput) {
            date = this.pickedDateInput;
        }
        let options:any;
        //Rajouter ici les options des filtres
       
        this.liste = [];
        this.getConsultations(date)
	}
	
	onSelectionChange(event: any) {
		        const selectedValue = event.value;
		        if (selectedValue === 'month') {
		            this.displayCalendarWeek = false;
		          
		        }else{
		            this.displayCalendarWeek = true;
		        }
				this.showData();
	}
	
	updateEvent(event:any,consultation:any) {
	           console.log("ConsultationIndexComponent  updated",consultation,event);
			
			this.showData();
	} 
	
	getLastDayOfMonth(date: string | number | Date) {
	       date = new Date(date);
	       let year = date.getFullYear();
	       let month = date.getMonth();
	       let fulldate = new Date(year, month + 1, 0);
	       return fulldate.getDate();
	   }

	
	firstDayOfMonth(date: string | number | Date){
	        date = new Date(date);
	        let day = "01";
	        let transition = date.getMonth() + 1;
	        let month = transition<10?"0"+transition:transition;
	        let year = date.getFullYear();
	        //console.log(" in firstDayOfMonth:",day+"/"+month+"/"+year);
	        return  new Date(year+"/"+month+"/"+day);
	    }

    lastDayOfMonth(date: string | number | Date){
        date = new Date(date);
        let day = this.getLastDayOfMonth(date);
        let transition = date.getMonth() + 1;
        let month = transition<10?"0"+transition:transition;
        let year = date.getFullYear();
        return  new Date(year+"/"+month+"/"+day);

    }

}
